module.exports = __webpack_public_path__ + "static/img/W.fe0cefe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/W.png
// module id = IkuE
// module chunks = 0